import { FC } from "react";
import { AiChatMessageType, FetchAiChatMessagesByAiImportIdQuery } from "@/graphql/__generated__/graphql";
import { TFunction } from "i18next";
import MessageRenderer from "./MessageRenderer";

/**
 * Props for the ChatMessagesList component
 */
interface ChatMessagesListProps {
  /** Array of messages from the database */
  messages: FetchAiChatMessagesByAiImportIdQuery["fetchAiChatMessagesByAIImportId"] | undefined;
  /** i18n translate function */
  t: TFunction;
  /** Handler for resending messages */
  onResend: (_resendText: string) => void;
}

/**
 * Component that renders the list of chat messages from the database.
 * Handles finding previous user messages for refresh functionality.
 *
 * @component
 * @example
 * <ChatMessagesList
 *   messages={dbMessages}
 *   t={t}
 *   onResend={handleResend}
 * />
 */
export const ChatMessagesList: FC<ChatMessagesListProps> = ({ messages, t, onResend }) => {
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <>
      {messages.map((msg, idx, arr) => (
        <MessageRenderer
          key={msg.id}
          message={msg}
          t={t}
          onResend={onResend}
          getPreviousUserMessage={() => {
            // Find the previous user message for refresh functionality
            for (let i = idx - 1; i >= 0; i--) {
              if (arr[i].type === AiChatMessageType.Question) {
                return arr[i].text;
              }
            }
            return undefined;
          }}
        />
      ))}
    </>
  );
};
